import "./App.css";
import { useLocation, BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

// Components
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import ImageCarousel from "./components/ImageCarousel";
import HighlightsSection from "./components/HighlightsSection";
import AboutSection from "./components/AboutSection";
import OurSpecialists from "./components/OurSpecialists"; // your original team section
import ServicesSection from "./components/ServicesSection";
import ServicesPage from "./components/ServicesPage";
import BranchesSection from "./components/BranchesSection";
import TestimonialsSection from "./components/TestimonialsSection";
import CorporateWellnessSection from "./components/CorporateWellnessSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import GalleryPage from "./components/GalleryPage";
import RotatingContactButton from "./components/RotatingContactButton";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { auth, db } from "./firebase";
import { doc, getDoc } from "firebase/firestore";
import Careers from "./components/Careers";
import DoctorDashboard from "./components/dashboard/DoctorDashboard";
import PatientDashboard from "./components/dashboard/PatientDashboard";
import PatientPage from "./components/dashboard/PatientPage";

// Auth
import Login from "./components/auth/Login";
import SignUp from "./components/auth/SignUp";

// Dashboards

import AdminDashboard from "./components/dashboard/AdminDashboard";

// Extra Pages
import ChiefPhysiotherapist from "./components/ChiefPhysiotherapist";
import BookAppointment from "./components/BookAppointment";
import SportsInjuryRecovery from "./components/SportsInjuryRecovery";
import PainReliefManagement from "./components/PainReliefManagement";
import ChiropracticCare from "./components/ChiropracticCare";
import Rehabilitation from "./components/Rehabilitation";
import CustomizedWellnessPrograms from "./components/CustomizedWellnessPrograms";
import CorporateWellness from "./components/CorporateWellness";
import HomeVisitPage from "./components/HomeVisit";
import VirtualConsultationPage from "./components/VirtualConsultation";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsAndConditions from "./components/TermsAndConditions";

// UI
import { Toaster } from "./components/ui/toaster";
import React, { useEffect, useState, Suspense, lazy } from "react";
import TokenRegister from "./pages/TokenRegister";
import QRPage from "./pages/QRPage";
import AdminTodayQueue from "./components/dashboard/AdminTodayQueue";
import PatientRegistration from "./vpjc-patient-forms/pages/PatientRegistration";
import PatientFormsApp from "./vpjc-patient-forms/PatientFormsApp";
import PatientFeedback from "./vpjc-patient-forms/pages/PatientFeedback";

function ProtectedRoute({ children, roleRequired }) {
  const [loading, setLoading] = useState(true);
  const [userRole, setUserRole] = useState(null);
  const [user, setUser] = useState(null);

  // Load user from localStorage on mount
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) setUser(JSON.parse(storedUser));
  }, []);

  const handleLogout = async () => {
    try {
      await signOut(auth).catch(() => {}); // ignore for guest
    } catch (e) {
      console.error(e);
    }
    localStorage.removeItem("user");
    setUser(null);
    window.location.href = "/login"; // redirect to login
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        try {
          const userDoc = await getDoc(doc(db, "users", user.uid));
          const role = userDoc.exists() ? userDoc.data().role : null;
          setUserRole(role);
        } catch (error) {
          console.error("Error fetching user role:", error);
          setUserRole(null);
        }
      } else {
        setUserRole(null);
      }
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  if (loading)
    return <p className="text-center mt-10">Checking permissions...</p>;
  if (!userRole || (roleRequired && userRole !== roleRequired))
    return <Navigate to="/login" />;
  return children;
}

// ScrollToTop component to scroll to top on route change

function ScrollToTop() {
  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname]);

  return null;
}
const Home = () => {
  const [showTopBtn, setShowTopBtn] = useState(false);

  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setShowTopBtn(window.scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Scroll to section if navigated with state

  useEffect(() => {
    if (location.state && location.state.scrollTo) {
      const el = document.getElementById(location.state.scrollTo);

      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth" });
        }, 100);
      }
    }
  }, [location.state]);
  const ScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <Header />

      {/* Main Content */}
      <main>
        <section id="home"></section>
        <HeroSection />
        <ImageCarousel />
        <HighlightsSection />
        <section id="about"></section>
        <AboutSection />
        <section id="team"></section>
        <OurSpecialists />
        <section id="services"></section>
        <ServicesSection />
        <section id="branches"></section>
        <BranchesSection />
        <TestimonialsSection />
        <CorporateWellnessSection />
        <section id="contact"></section>
        <ContactSection />
      </main>

      {/* Footer */}
      <Footer />
       {showTopBtn && <RotatingContactButton />}
    </div>
  );
};

function App() {
  const [showTopBtn, setShowTopBtn] = React.useState(false);

  React.useEffect(() => {
    const handleScroll = () => {
      setShowTopBtn(window.scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  
  
  const protectedRoutes = [
    "/admin-dashboard",
    "/branch-doctors",
    "/doctor-dashboard",
    "/patient-dashboard",
    "/admin"
  ];

// const location = useLocation(); 
// const isProtected = protectedRoutes.includes(location.pathname);


  return (
    <div className="App">
      {/* Show banner only in development */}
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/qr" element={<QRPage />} />
          <Route path="/token" element={<TokenRegister />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/book-appointment" element={<BookAppointment />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/harish-jasti" element={<ChiefPhysiotherapist />} />
          <Route path="/home-visit" element={<HomeVisitPage />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/branches" element={<BranchesSection />} />

          <Route
            path="/virtual-consultation"
            element={<VirtualConsultationPage />}
          />
          {/* <Route path="/team" element={<OurSpecialistsPage />} /> */}
          {/* Service Detail Pages */}
          <Route
            path="/sports-injury-recovery"
            element={<SportsInjuryRecovery />}
          />
          <Route
            path="/pain-relief-management"
            element={<PainReliefManagement />}
          />
          <Route path="/chiropractic-care" element={<ChiropracticCare />} />
          <Route path="/rehabilitation" element={<Rehabilitation />} />
          <Route
            path="/customized-wellness-programs"
            element={<CustomizedWellnessPrograms />}
          />
          <Route path="/corporate-wellness" element={<CorporateWellness />} />

          {/* Protected Dashboard Routes */}
          <Route
            path="/admin-dashboard"
            element={
              <ProtectedRoute roleRequired="admin">
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route path="/admin" element={<AdminTodayQueue />} />
          <Route path="/admin/patient" element={<PatientPage />} />
          <Route
            path="/doctor-dashboard"
            element={
              <ProtectedRoute roleRequired="doctor">
                <DoctorDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/patient-dashboard"
            element={
              <ProtectedRoute roleRequired="patient">
                <PatientDashboard />
              </ProtectedRoute>
            }
          />

          {/* Catch-all route */}
          <Route path="*" element={<Home />} />

          <Route
          path="/patient-registration-form"
          element={<PatientRegistration />}
        />
         <Route
          path="/patient-feedback-form"
          element={<PatientFeedback />}
        />
          
          <Route
            path="/patient-forms"
            element={<PatientFormsApp />}
          />

        </Routes>

        {/* Toast Notifications */}
        <Toaster />

        {/* Floating Contact Button - visible on all pages */}
        {/* {!isProtected && showTopBtn && <RotatingContactButton />} */}
      </BrowserRouter>
    </div>
  );
}

export default App;
